import { identity } from 'lodash';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid, GridSize } from '@mui/material';

import { FORM_ERROR_MAPPING } from 'src/constants';
import { TDropItem } from 'src/types';

import CheckboxField from './CheckboxField';
import Typography from './Typography';

interface CheckGroupFieldProps {
  name: string;
  label?: string;
  readOnly?: boolean;
  required?: boolean;
  options: TDropItem[];
  showManualError?: boolean;
  validator?: any;
  layout?: {
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
    lg?: GridSize;
  };
}

const CheckGroupField: FC<CheckGroupFieldProps> = ({
  label,
  name,
  readOnly,
  required,
  options,
  layout,
  showManualError,
  validator,
}) => {
  const { watch } = useFormContext();

  const formValues = watch();
  let errorMessage = null;

  if (showManualError && validator?.validate && !validator?.validate(formValues)) {
    errorMessage = validator?.validationMessage ?? FORM_ERROR_MAPPING.invalid;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="body1">{label}</Typography>
      </Grid>

      {options.map((option) => (
        <Grid item key={option.value} xs={layout?.xs} sm={layout?.sm} md={layout?.md} lg={layout?.lg}>
          <CheckboxField
            name={[name, option.value].filter(identity).join('.')}
            label={option.label}
            readOnly={readOnly}
            required={required}
          />
        </Grid>
      ))}

      {errorMessage ? (
        <Grid item xs={12}>
          <Typography variant="body1" hasError>
            {errorMessage}
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default CheckGroupField;
